export default __webpack_public_path__ + "static/me-2ae028e18390bc41465c5e9d27df90ac.webp";